'use strict';

import _ from 'lodash';

import './CheckoutPage.less';

import checkoutCloudLeft from 'ck-core-client/graphics/checkout/checkout-cloud-left.svg';

import React from 'react';
import PropTypes from 'prop-types';
import { ConnectedCheckoutStages } from 'ck-website/source/components/CheckoutStages';
import Frame from 'ck-core-client/source/ui/Frame';
import availablePlanTypes from 'ck-core/source/functions/availablePlanTypes';
import { CHOICES as PANEL_CHOICES } from './AccountPageInner';

export function generateCheckoutProps(options) {
	options = _.defaults(options || {}, {
		currentPlanType: CK.user.currentPlanType()
	});

	const { currentPlanType, planDuration: duration, product, size } = options;

	if (!product || !duration) {
		return {
			redirect: '/plans/'
		};
	}

	if (CK.user.linkedTo()) {
		return {
			redirect: `/account/?panel=${PANEL_CHOICES.PLAN.name}`
		};
	}

	const planTypes = availablePlanTypes(currentPlanType);

	const props = {
		choices: {
			duration,
			product,
			size
		},
		planTypes,
		currentPlanType
	};

	return props;
}

export default class CheckoutPage extends React.Component {
	render() {
		const query = this.props.args[1];

		const checkoutProps = generateCheckoutProps({
			...query
		});

		if (checkoutProps.redirect) {
			Frame.mod().navigate(checkoutProps.redirect);
			return null;
		}

		return (
			<div className="CheckoutPage">
				<img src={checkoutCloudLeft} className="CheckoutPage__cloud--left" />
				<ConnectedCheckoutStages {...checkoutProps} />
			</div>
		);
	}
}

CheckoutPage.propTypes = {
	args: PropTypes.any
};

export const title = require('ck-core-client/source/functions/generatePageTitle')(
	require('./CheckoutPageLang').TITLE
);
